import { createFeature, createReducer } from '@ngrx/store';

import { jobAddDiscountsModalReducers } from './add-discounts-modal.reducers';
import { jobAddDiscountsModalInitialState } from './add-discounts-modal.state';

export const addDiscountsModalFeature = createFeature({
  name: 'jobV3AddDiscountsModal',
  reducer: createReducer(jobAddDiscountsModalInitialState, ...jobAddDiscountsModalReducers),
});
